import { ChangeDetectionStrategy, Component, computed, Directive, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../shared/store/application-state';
import { Logout } from '../../shared/store/logout.action';
import { UserQuery } from '../../shared/store/reducers/user.reducer';
import { NavigationQuery } from '../store/navigation.reducer';

@Directive({})
export class HeaderComponentBase {

	private readonly router = inject(Router);
	private readonly store = inject<Store<ApplicationState>>(Store);

	items = computed(() => this.store.selectSignal(NavigationQuery.items)()
		.filter(item => !item.parameters['showInAltNav']));
	showMainNav = this.store.selectSignal(NavigationQuery.showMainNav);

	preferencesTooltip = computed(() => {
		const user = this.store.selectSignal(UserQuery.getUser)();
		return user && `${ user.firstname } ${ user.surname } (${ user.userId })`;
	});

	private activeId = this.store.selectSignal(NavigationQuery.getActiveId);
	basketActive = computed(() => this.activeId() === 'basket');
	prefsActive = computed(() => this.activeId() === 'preferences');
	contactActive = computed(() => this.activeId() === 'contact');

	constructor() {
	}

	logout(route: string = '/logout.do') {
		this.store.dispatch(new Logout);
		this.router.navigateByUrl(route);
	}
}
